import React, { useState, useEffect } from 'react';
import api from '../../api/ApiClient';

const H = { padding: '10px 14px', textAlign: 'left', fontSize: 11, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.07em', fontWeight: 600, background: 'var(--surface2)', borderBottom: '1px solid var(--border)' };
const TD = { padding: '12px 14px', borderBottom: '1px solid var(--border)', fontSize: 13, color: 'var(--text-2)' };

export default function MySales() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getOrders('sold').then(d => setOrders(d.orders || [])).finally(() => setLoading(false));
  }, []);

  const earned = orders.filter(o => o.status === 'completed').reduce((s, o) => s + o.amount, 0);

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', letterSpacing: '-0.5px', marginBottom: 24 }}>Sales</h1>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 14, marginBottom: 28 }}>
        {[
          ['Total earned', `$${earned.toFixed(2)}`, 'var(--success)'],
          ['Total sales', orders.length, 'var(--text)'],
          ['Disputed', orders.filter(o => o.status === 'disputed').length, 'var(--danger)'],
        ].map(([l, v, c]) => (
          <div key={l} className="card" style={{ padding: '18px 20px' }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 6 }}>{l}</div>
            <div style={{ fontSize: 24, fontWeight: 700, color: c, fontFamily: 'Space Mono', letterSpacing: '-0.5px' }}>{v}</div>
          </div>
        ))}
      </div>

      {loading && <div style={{ color: 'var(--text-3)' }}>Loading…</div>}

      {!loading && orders.length === 0 && (
        <div className="card" style={{ padding: '60px 24px', textAlign: 'center' }}>
          <p style={{ color: 'var(--text-2)' }}>No sales yet. Publish your assets to start earning.</p>
        </div>
      )}

      {!loading && orders.length > 0 && (
        <div className="card" style={{ overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>{['Asset', 'Buyer', 'Amount', 'Status', 'Date'].map(h => <th key={h} style={H}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {orders.map((o) => {
                const a = o.assetId || {};
                const b = o.buyerId || {};
                const stColor = o.status === 'completed' ? '#16A34A' : o.status === 'disputed' ? '#DC2626' : '#64748B';
                const stBg    = o.status === 'completed' ? '#F0FDF4' : o.status === 'disputed' ? '#FEF2F2' : '#F1F5F9';
                return (
                  <tr key={o._id}
                    onMouseOver={e => e.currentTarget.style.background = 'var(--surface2)'}
                    onMouseOut={e => e.currentTarget.style.background = ''}
                  >
                    <td style={{ ...TD, maxWidth: 200, color: 'var(--text)', fontWeight: 500 }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.title || 'Unknown'}</div>
                    </td>
                    <td style={TD}>{b.name || '—'}</td>
                    <td style={{ ...TD, fontWeight: 700, fontFamily: 'Space Mono', color: 'var(--success)' }}>${o.amount}</td>
                    <td style={TD}>
                      <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 4, fontWeight: 600, color: stColor, background: stBg }}>{o.status}</span>
                    </td>
                    <td style={{ ...TD, color: 'var(--text-3)' }}>{new Date(o.createdAt).toLocaleDateString()}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
